module.exports = __webpack_public_path__ + "img/assignee-warning.648b9f29.svg";